/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import userReducer from './user/userSlice'
import initializedReducer from './initialized/initializedSlice'
import orgApplicationsReducer from './organization/applications/orgApplicationSlice'
import organizationReducer from './organization/organization/organizationSlice'
 
export const appReducer = {

  user: userReducer,
  initialized: initializedReducer,
  orgApplications: orgApplicationsReducer,
  organization: organizationReducer,
} 